import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type UpdateAccountMemberUserGroupMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateAccountMemberUserGroupInput;
}>;

export type UpdateAccountMemberUserGroupMutationResult = { __typename?: 'Mutation' } & {
  updateAccountMemberUserGroup?: GraphQLTypes.Maybe<
    { __typename?: 'UpdateAccountMemberUserGroupPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UpdateAccountMemberUserGroupDocument = gql`
  mutation updateAccountMemberUserGroup($input: UpdateAccountMemberUserGroupInput!) {
    updateAccountMemberUserGroup(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
